<body class="card h-100 shadow-sm">
  <img
    [src]="product().image"
    class="card-img-top object-fit-cover"
    style="height: 300px"
    alt="{{ product().name }}"
  />

  <div class="card-body d-flex flex-column">
    <a class="card-title" [routerLink]="['/','product', product().id]">{{ product().name }}</a>

    <p class="text-muted small mb-1">
      {{ product().categoryName }}
    </p>

    <p class="card-text flex-grow-1">
      {{ product().description }}
    </p>

    <div class="d-flex justify-content-between align-items-center mt-2">
      <span class="fw-bold fs-5"> ${{ product().price }} </span>

      <button class="btn btn-dark btn-sm" (click)="addToCart(product().id)">Add to cart</button>
    </div>
  </div>
</body>
